const listRefresh = {
  MIN_INVALID_TRADES: 3,
  CHECK_LIST_INTERVAL: 60 * 1000 * 5
};

export default listRefresh;
